import React from 'react';
import Countdown from 'react-countdown';
import useMain from '../../../hooks/useMain';
import { numberWithCommas } from '../../../utils/helpers';
import Image from '../../common/image';
import { TextCard } from '../ingredients/cards';
import InvestmentDashboardTable from '../ingredients/investmentDashboardTable';

const InvestmentDashboard = () => {
	const { initData, userData } = useMain();
	const { cards, sum } = userData.investmentData;

	return (
		<div className='row'>
			<div className='col-12'>
				<TextCard
					titleClass={''}
					title={''}
					text={
						<>
							<div className='row'>
								<div className='col text-center'>
									<h4>Next Staking Distribution Time:</h4>
									<Countdown
										className='h2'
										onComplete={() => window.location.reload()}
										date={initData.stakingTime + 15000}
									/>
								</div>
							</div>
							<hr />
							{userData.currentCard.name === 'white' ? (
								<div className='row my-5'>
									<div className='col text-center'>
										<Image
											fileName='icons/warn.svg'
											height='100px'
											className='mb-3'
										/>
										<h4>You do not have any active package right now.</h4>
									</div>
								</div>
							) : (
								<div className='row my-5'>
									<div className='col-sm-8 offset-sm-2 col-12 text-center'>
										<h4 className='mb-4'>My Active Investments:</h4>
										<InvestmentDashboardTable data={cards} />

										<h5 className='mt-4'>
											This month total profit: $
											{numberWithCommas(Math.round((sum * 100) / 1e6) / 100)}
										</h5>
									</div>
								</div>
							)}
						</>
					}
				/>
			</div>
		</div>
	);
};

export default InvestmentDashboard;
